import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitBranchShowCurrentAction extends WorkerAction {
  type: GitAction.BranchShowCurrent;
}

export class GitBranchShowCurrentActionError extends WorkerActionError {}

export async function GitBranchShowCurrentActionFn(
  params: WorkerFnParams<GitBranchShowCurrentAction>,
): Promise<string> {
  try {
    const status = params.lg.callAndCaptureOutput(['status']);
    return status.split('\n')[0]?.replace('On branch', '').replace('#', '').trim() ?? '';
  } catch (err) {
    throw new GitBranchShowCurrentActionError(err);
  }
}
